import * as React from 'react';
import PropTypes from 'prop-types';
import GatsbyImage from 'gatsby-image';
import { useStaticQuery, graphql, Link } from 'gatsby';

import { useGraphQL } from '../hooks';

import { InstagramImages } from './instagram';

function BlogPosts({ allShopifyArticle }) {
  // Number of blog posts to show at a time
  const [numToShow, setNumToShow] = React.useState(5);

  const { heroBlogImage } = useStaticQuery(graphql`
    {
      heroBlogImage: file(relativePath: { eq: "blog/blog-hero.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1280) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  const { blogSidebarLadies, blogSidebarMens } = useGraphQL();

  return (
    <article className="w-full mx-auto max-w-7xl">
      <GatsbyImage
        fluid={heroBlogImage.childImageSharp.fluid}
        className="relative mb-16 max-h-96"
      />
      <div className="grid w-full grid-cols-1 gap-12 mx-auto lg:grid-cols-3 max-w-7xl">
        <div className="col-span-2 px-8">
          <h1 className="text-center h2">Stay Connected With Our Blogs</h1>
          <ul>
            {allShopifyArticle.nodes.map((blogPost, index) => {
              if (index < numToShow) {
                return (
                  <li key={blogPost.id} className="mt-12">
                    <div className="">
                      <div className="flex flex-col overflow-hidden sm:flex-row">
                        <div className="flex-shrink-0">
                          <Link
                            tabIndex={-1}
                            aria-hidden
                            to={`/blogs/${blogPost.categories[0].title.toLowerCase()}/${
                              blogPost.slug.current
                            }`}
                            className="block focus:outline-none group"
                          >
                            <img
                              className="object-cover w-full h-48 sm:w-64 sm:h-64"
                              src={blogPost.mainImage.asset.fluid.src}
                              alt="asdf"
                            />
                          </Link>
                        </div>
                        <div className="flex flex-col justify-between flex-1 p-6 bg-white">
                          <div className="flex-1">
                            <Link
                              to={`/blogs/${blogPost.categories[0].title.toLowerCase()}/${
                                blogPost.slug.current
                              }`}
                              className="block focus:outline-none group"
                            >
                              <h3 className="mt-2 text-xl font-bold leading-7 text-gray-900 uppercase group-hover:underline group-focus:underline">
                                {blogPost.title}
                              </h3>
                              <div className="mt-4 prose">
                                <p className="clamp-3">
                                  {blogPost._rawBody.map(
                                    (p) =>
                                      p.children && `${p.children[0].text} `
                                  )}
                                </p>
                              </div>
                            </Link>
                          </div>
                          <div className="mt-6">
                            <p className="text-sm font-bold leading-5 text-gray-900">
                              {blogPost.author.name}
                            </p>
                            <div className="text-sm italic font-bold leading-5 text-gray-700">
                              <time dateTime="2020-03-16">
                                {blogPost.publishedAt}
                              </time>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </div>
        <div className="hidden lg:block lg:col-span-1">
          <h1 className="text-center h2">Featured Post</h1>
          <ul className="px-6 border-l-2 border-gray-500">
            {allShopifyArticle.nodes.map((blogPost) => {
              if (blogPost.categories.find((i) => i.title === 'Featured'))
                return (
                  <li key={blogPost.id} className="mt-6">
                    <div className="">
                      <div className="flex flex-col items-center overflow-hidden rounded-lg">
                        <div className="flex-shrink-0">
                          <Link
                            tabIndex={-1}
                            aria-hidden
                            to={`/blogs/${blogPost.categories[0].title.toLowerCase()}/${
                              blogPost.slug.current
                            }`}
                            className="block focus:outline-none group"
                          >
                            <img
                              className="object-cover w-full h-48 sm:w-64 sm:h-48"
                              src={blogPost.mainImage.asset.fluid.src}
                              alt="asdf"
                            />
                          </Link>
                        </div>
                        <div className="flex flex-col justify-between flex-1 p-6 -mt-10">
                          <div className="flex-1">
                            <Link
                              to={`/blogs/${blogPost.categories[0].title.toLowerCase()}/${
                                blogPost.slug.current
                              }`}
                              className="block focus:outline-none group"
                            >
                              <h3 className="mt-6 text-xl font-bold leading-7 text-gray-900 group-hover:underline group-focus:underline">
                                {blogPost.title}
                              </h3>
                              <div className="mt-4 prose">
                                <p className="clamp-3">
                                  {blogPost._rawBody.map(
                                    (p) =>
                                      p.children && `${p.children[0].text} `
                                  )}
                                </p>
                              </div>
                            </Link>
                          </div>
                          <div className="flex items-center justify-start mt-6">
                            <p className="text-sm font-bold leading-5 text-gray-900">
                              {blogPost.author.name} |
                            </p>
                            <div className="ml-1 text-sm italic font-bold leading-5 text-gray-700">
                              <time dateTime="2020-03-16">
                                {blogPost.publishedAt}
                              </time>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              return null;
            })}
            <h1 className="mt-8 text-center h2">Instagram</h1>
            <div className="grid grid-cols-2">
              <InstagramImages imagesToShow={4} />
            </div>
            <Card
              theme="ladies"
              fluid={blogSidebarLadies.childImageSharp.fluid}
              imgStyle={{ objectPosition: 'top' }}
              heading={
                <span className="text-3xl">
                  Shop ladies clothing and accessories
                </span>
              }
              slug="/ladies/"
              linkLabel="Shop Ladies"
            />
            <Card
              theme="mens"
              fluid={blogSidebarMens.childImageSharp.fluid}
              heading={
                <span className="text-3xl">
                  Shop mens clothing and accessories
                </span>
              }
              slug="/mens/"
              linkLabel="Shop Mens"
            />
          </ul>
        </div>
      </div>
      {numToShow <= allShopifyArticle.nodes.length && (
        <div className="text-center">
          <button
            onClick={() => setNumToShow(numToShow + 5)}
            type="button"
            className="px-5 py-3 my-8 text-xl font-bold tracking-widest transition duration-150 ease-in-out border border-black hover:bg-black hover:text-white focus:outline-none focus:shadow-outline focus:bg-black focus:text-white"
          >
            LOAD MORE
          </button>
        </div>
      )}
      <h1 className="block mt-8 text-center sm:hidden h2">Instagram</h1>
      <div className="grid grid-cols-2 sm:hidden">
        <InstagramImages imagesToShow={4} />
      </div>
      <div className="block mx-4 sm:hidden">
        <Card
          theme="ladies"
          fluid={blogSidebarLadies.childImageSharp.fluid}
          imgStyle={{ objectPosition: 'top' }}
          heading={
            <span className="text-3xl">
              Shop ladies clothing and accessories
            </span>
          }
          slug="/ladies/"
          linkLabel="Shop Ladies"
        />
        <Card
          theme="mens"
          fluid={blogSidebarMens.childImageSharp.fluid}
          heading={
            <span className="text-3xl">Shop mens clothing and accessories</span>
          }
          slug="/mens/"
          linkLabel="Shop Mens"
        />
      </div>
    </article>
  );
}

BlogPosts.propTypes = {
  allShopifyArticle: PropTypes.object.isRequired,
};

function Card({ theme, fluid, imgStyle, heading, slug, linkLabel }) {
  let colours = '';
  if (theme === 'ladies')
    colours = 'border-brand-pink bg-brand-pink hover:text-brand-pink';
  if (theme === 'mens')
    colours = 'border-brand-blue bg-brand-blue hover:text-brand-blue';
  return (
    <div className="relative mt-8">
      <div className="h-0 aspect-ratio-square">
        <div className="absolute inset-0 w-full h-full">
          <GatsbyImage fluid={fluid} imgStyle={imgStyle} className="h-full" />
        </div>
        <div className="absolute inset-0 w-full h-full bg-black opacity-50" />
      </div>
      <div className="absolute inset-0 flex items-end">
        <div
          aria-hidden
          className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient"
        />
        <div className="relative flex-col items-center flex-1 p-8 text-center text-white">
          <h2 className="h2">{heading}</h2>
          <h3 className="mt-2 text-lg h2">Head to toe looks</h3>
          <Link
            to={slug}
            className={`${colours} inline-block px-8 py-2 mt-4 text-sm font-bold tracking-wider uppercase transition duration-150 ease-in-out border hover:bg-white hover:border-white focus:outline-none focus:shadow-outline-primary`}
          >
            {linkLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}

Card.propTypes = {
  theme: PropTypes.string.isRequired,
  fluid: PropTypes.object.isRequired,
  heading: PropTypes.node.isRequired,
  imgStyle: PropTypes.object,
  slug: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
};

export { BlogPosts };
